import { useState, useRef, useEffect } from "react";

// ─── FULL STORE KNOWLEDGE ─────────────────────────────────────────────────────
const TOOLS = [
  {
    id: 7,
    icon: "📧",
    name: "EMrex",
    price: 10,
    original: 50,
    category: "Email Management",
    tagline: "Ultimate Email Account Manager",
    desc: "Manage unlimited email accounts. Login, connect TikTok/FB/IG, export CSV, full dashboard.",
    features: [
      "Unlimited Accounts",
      "Secure Login",
      "Platform Connect",
      "CSV Export",
      "Dashboard",
    ],
    best: "marketers, agencies, social media managers",
    discount: "80% OFF — Limited Time",
  },
  {
    id: 8,
    icon: "🎬",
    name: "DL REX",
    price: 9.99,
    original: 15,
    category: "Video Tools",
    tagline: "Professional Bulk Video Downloader",
    desc: "Download from TikTok, YouTube, Instagram & 1000+ sites. Watermarks, color grade, account watcher 24/7.",
    features: [
      "Bulk Download",
      "Watermark Editor",
      "Account Watcher",
      "1000+ Sites",
      "Proxy Support",
    ],
    best: "content creators, agencies, video editors",
    plans: ["$9.99/mo", "$29.99/yr", "$69.99 Lifetime", "$149 Team"],
  },
  {
    id: 1,
    icon: "⚡",
    name: "AutoFlow AI",
    price: 29,
    original: 49,
    category: "Automation",
    tagline: "Automate repetitive tasks with zero code",
    desc: "Connect 200+ apps with AI-powered automation. Notion, Telegram, GitHub, Gmail and more.",
    features: [
      "200+ Integrations",
      "AI Logic",
      "Live Analytics",
      "1-Click Deploy",
      "Team Collab",
    ],
    best: "developers and marketers who want to automate workflows",
  },
  {
    id: 2,
    icon: "🧠",
    name: "PromptCraft Pro",
    price: 19,
    original: 35,
    category: "AI",
    tagline: "Build, test & sell AI prompts",
    desc: "Professional workspace for prompt engineers. Test across GPT-4, Claude, Gemini simultaneously.",
    features: [
      "Multi-model testing",
      "Prompt library",
      "Version control",
      "Analytics",
    ],
    best: "AI engineers and prompt engineers",
  },
  {
    id: 3,
    icon: "📊",
    name: "DataPulse",
    price: 24,
    original: 40,
    category: "Analytics",
    tagline: "Spreadsheets to Live Dashboards",
    desc: "Upload CSV or Google Sheets. Get beautiful shareable dashboards in seconds.",
    features: [
      "CSV Import",
      "Live Dashboards",
      "Shareable links",
      "Custom charts",
    ],
    best: "data analysts and business owners",
  },
  {
    id: 4,
    icon: "🔗",
    name: "LinkVault",
    price: 12,
    original: 20,
    category: "Marketing",
    tagline: "Smart bio links + analytics",
    desc: "One link that adapts based on device, location or time of day.",
    features: [
      "Smart redirects",
      "Device targeting",
      "Click analytics",
      "QR codes",
    ],
    best: "content creators and social media managers",
  },
  {
    id: 5,
    icon: "🛡️",
    name: "SecureVault",
    price: 9,
    original: 15,
    category: "Security",
    tagline: "Encrypted secrets manager",
    desc: "Store API keys, passwords and sensitive notes with military-grade encryption.",
    features: [
      "Military encryption",
      "API key storage",
      "Password manager",
      "Team sharing",
    ],
    best: "developers managing API keys and passwords",
  },
  {
    id: 6,
    icon: "✍️",
    name: "WriteBoost",
    price: 15,
    original: 25,
    category: "Writing",
    tagline: "AI writing for professionals",
    desc: "Rewrite, expand, summarize or translate any text across 20+ industries.",
    features: [
      "Rewrite & expand",
      "50+ languages",
      "Tone adjustment",
      "20+ industries",
    ],
    best: "writers, marketers, content creators",
  },
];

const C = {
  bg:        "#060810",
  surface:   "#0d0f1e",
  surface2:  "#111428",
  border:    "rgba(99,102,241,0.18)",
  accent:    "#a5b4fc",
  accentDim: "rgba(99,102,241,0.1)",
  accentGlow:"rgba(99,102,241,0.3)",
  green:     "#34d399",
  text:      "#e8eaff",
  muted:     "#6b7ba8",
  gold:      "#fbbf24",
  danger:    "#f87171",
  orange:    "#fb923c",
};

const QUICK = [
  { label: "🔍 Search tools", text: "search automation" },
  { label: "📧 EMrex", text: "Tell me about EMrex" },
  { label: "🎬 DL REX", text: "Tell me about DL REX" },
  { label: "📊 Compare all", text: "compare all tools" },
  { label: "💰 Cheapest?", text: "cheapest tool" },
  { label: "🛒 How to buy?", text: "how to buy" },
  { label: "🏆 Most popular", text: "most popular tools" },
  { label: "💼 Sell my tool", text: "how can I sell my tool" },
];

// ─── SMART BRAIN ──────────────────────────────────────────────────────────────
function smartReply(msg) {
  const m = msg.toLowerCase().trim();

  if (
    m.match(/^(hi|hello|hey|sup|yo|hola|good\s|morning|evening|what.?s up)/)
  ) {
    const h = new Date().getHours();
    const g =
      h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening";
    return {
      text: `${g}! 👋 Welcome to **TOOLREX.ONLINE**!\n\nI'm **AI Rex** — your smart store assistant.\n\n- 🔍 **Search** tools by feature or keyword\n- 💰 **Compare** all prices side by side\n- 🛒 **Guide** you through buying step by step\n- 🤔 **Recommend** the perfect tool for you\n\nWhat can I help you with today?`,
      type: "text",
    };
  }

  if (
    m.startsWith("search") ||
    m.startsWith("find") ||
    m.startsWith("look for")
  ) {
    const q = msg.replace(/^(search|find|look for)\s*/i, "").trim();
    const res = TOOLS.filter(
      (t) =>
        t.name.toLowerCase().includes(q.toLowerCase()) ||
        t.category.toLowerCase().includes(q.toLowerCase()) ||
        t.desc.toLowerCase().includes(q.toLowerCase()) ||
        t.features.some((f) => f.toLowerCase().includes(q.toLowerCase())),
    );
    if (!res.length)
      return {
        text: `🔍 No tools found for **"${q}"**.\n\nTry: automation, email, video, writing, security, analytics, marketing`,
        type: "text",
      };
    return {
      text: `🔍 Found **${res.length} tool${res.length > 1 ? "s" : ""}** matching "${q}":`,
      type: "tools",
      tools: res,
    };
  }

  if (
    m.includes("compare") ||
    m.includes(" vs ") ||
    (m.includes("which") && m.includes("better")) ||
    m.includes("price") ||
    m.includes("pricing") ||
    m.includes("how much") ||
    m.includes("cost")
  ) {
    return {
      text: `💰 **All ${TOOLS.length} tools compared:**`,
      type: "compare",
    };
  }

  if (
    m.includes("all tool") ||
    m.includes("show all") ||
    m.includes("list all") ||
    m.includes("what tool")
  ) {
    return {
      text: `Here are all **${TOOLS.length} tools** on TOOLREX.ONLINE:`,
      type: "tools",
      tools: TOOLS,
    };
  }

  if (
    m.includes("cheap") ||
    m.includes("afford") ||
    m.includes("budget") ||
    m.includes("cheapest") ||
    m.includes("lowest")
  ) {
    return {
      text: `💰 **Tools by price — lowest to highest:**`,
      type: "tools",
      tools: [...TOOLS].sort((a, b) => a.price - b.price),
    };
  }

  if (
    m.includes("popular") ||
    m.includes("best seller") ||
    m.includes("most used") ||
    m.includes("top tool") ||
    m.includes("recommend")
  ) {
    return {
      text: `🏆 **Top recommended tools:**\n\n🔥 **EMrex** — Most value ($10, was $50)\n🎬 **DL REX** — Newest & most featured\n⚡ **AutoFlow AI** — Most powerful automation\n\nHere they are:`,
      type: "tools",
      tools: [TOOLS[0], TOOLS[1], TOOLS[2]],
    };
  }

  if (m.includes("emrex") || (m.includes("email") && m.includes("manag")))
    return {
      text: `Here's everything about **EMrex**:`,
      type: "tool",
      tool: TOOLS[0],
    };
  if (
    m.includes("dl rex") ||
    m.includes("dlrex") ||
    (m.includes("download") && m.includes("video"))
  )
    return {
      text: `Here's everything about **DL REX**:`,
      type: "tool",
      tool: TOOLS[1],
    };
  if (m.includes("autoflow") || (m.includes("automat") && !m.includes("email")))
    return {
      text: `Here's everything about **AutoFlow AI**:`,
      type: "tool",
      tool: TOOLS[2],
    };
  if (m.includes("promptcraft") || m.includes("prompt craft"))
    return {
      text: `Here's everything about **PromptCraft Pro**:`,
      type: "tool",
      tool: TOOLS[3],
    };
  if (
    m.includes("datapulse") ||
    (m.includes("data") && m.includes("dashboard"))
  )
    return {
      text: `Here's everything about **DataPulse**:`,
      type: "tool",
      tool: TOOLS[4],
    };
  if (m.includes("linkvault") || m.includes("bio link"))
    return {
      text: `Here's everything about **LinkVault**:`,
      type: "tool",
      tool: TOOLS[5],
    };
  if (
    m.includes("securevault") ||
    (m.includes("password") && m.includes("manag"))
  )
    return {
      text: `Here's everything about **SecureVault**:`,
      type: "tool",
      tool: TOOLS[6],
    };
  if (m.includes("writeboost") || (m.includes("writ") && m.includes("tool")))
    return {
      text: `Here's everything about **WriteBoost**:`,
      type: "tool",
      tool: TOOLS[7],
    };

  if (
    m.includes("buy") ||
    m.includes("order") ||
    m.includes("purchase") ||
    m.includes("payment") ||
    m.includes("how to get")
  ) {
    return {
      text: `🛒 **How to buy on TOOLREX.ONLINE:**\n\n**1** — Choose your tool\n**2** — Select plan (Monthly / Yearly / Lifetime)\n**3** — Pay via:\n\n🏦 **ABA Pay** — Scan QR (Cambodia)\n✈️ **Telegram** — @zyrexdev_official\n💳 **Stripe** — Card payment\n🅿️ **PayPal** — PayPal balance\n📧 **Email** — zyrexdev.supporter@gmail.com\n\n**4** — Send payment proof on Telegram\n**5** — Get download link + license key in 1-4 hours!`,
      type: "text",
    };
  }

  if (
    m.includes("lifetime") ||
    m.includes("license") ||
    m.includes("subscription") ||
    m.includes("expire")
  ) {
    return {
      text: `🔑 **Lifetime License — What you get:**\n\n✅ **Pay once** — use forever\n✅ **Never expires** — truly permanent\n✅ **Free updates** — always latest version\n✅ **No subscriptions** — zero monthly fees\n✅ **Commercial use** — use in client projects\n\n💡 Every tool has a lifetime option. Pay once, use forever!`,
      type: "text",
    };
  }

  if (
    m.includes("contact") ||
    m.includes("support") ||
    m.includes("telegram") ||
    m.includes("email") ||
    m.includes("reach")
  ) {
    return {
      text: `📞 **Contact TOOLREX.ONLINE:**\n\n✈️ **Telegram** — @zyrexdev_official ⚡ 1-4 hours\n📧 **Email** — zyrexdev.supporter@gmail.com\n🏦 **ABA Pay** — Available for Cambodia\n⌥ **GitHub** — github.com/zyrex-developer\n\n💡 Telegram is always the fastest!`,
      type: "text",
    };
  }

  if (
    m.includes("about") ||
    m.includes("zyrex") ||
    m.includes("toolrex") ||
    m.includes("who made")
  ) {
    return {
      text: `🏪 **About TOOLREX.ONLINE:**\n\nCreated by **ZYREX** — 18-year-old indie developer building powerful tools for students, developers, and businesses.\n\n📅 Founded: 2026\n🛠️ Tools: ${TOOLS.length} available\n🔑 All: Lifetime available\n💳 Payments: ABA, Telegram, Stripe, PayPal\n\n💡 Want to sell your tool here? Keep **80%** of every sale! DM @zyrexdev_official`,
      type: "text",
    };
  }

  if (
    m.includes("sell") ||
    m.includes("list my tool") ||
    m.includes("my tool")
  ) {
    return {
      text: `💼 **Sell your tool on TOOLREX.ONLINE:**\n\n✅ Any developer can list their tool\n💰 You keep **80% of every sale**\n📦 ZYREX handles payments & delivery\n🚀 Access to our developer audience\n\n👉 DM **@zyrexdev_official** on Telegram!`,
      type: "text",
    };
  }

  if (
    m.includes("code") ||
    m.includes("coding") ||
    m.includes("javascript") ||
    m.includes("python") ||
    m.includes("react") ||
    m.includes("bug") ||
    m.includes("error")
  ) {
    return {
      text: `💻 **I can help with coding!**\n\nI can assist with:\n- JavaScript / React / Node.js\n- Python scripts\n- HTML / CSS\n- API integration\n- Debugging errors\n- Code reviews\n\n**Describe your problem and I'll help fix it!** 😊`,
      type: "text",
    };
  }

  if (
    m.includes("thank") ||
    m.includes("thanks") ||
    m.includes("great") ||
    m.includes("awesome") ||
    m.includes("perfect")
  ) {
    return {
      text: `You're welcome! 😊 Happy to help anytime!\n\nAnything else I can do for you? I'm here 24/7! 🚀`,
      type: "text",
    };
  }

  if (m.match(/^(bye|goodbye|see you|cya|later)/)) {
    return {
      text: `Goodbye! 👋 Thanks for visiting **TOOLREX.ONLINE**!\n\nAll tools start from just **$9** with lifetime licenses. Come back anytime! 🚀`,
      type: "text",
    };
  }

  // Smart fallback search
  const res = TOOLS.filter(
    (t) =>
      t.name.toLowerCase().includes(m) ||
      t.desc.toLowerCase().includes(m) ||
      t.features.some((f) => f.toLowerCase().includes(m)),
  );
  if (res.length)
    return {
      text: `🔍 Found something related to **"${msg}"**:`,
      type: "tools",
      tools: res,
    };

  return {
    text: `Thanks for your message! 😊\n\nHere's what I can help with:\n\n🔍 **"search [keyword]"** — Find tools\n📊 **"compare all tools"** — See all prices\n🛒 **"how to buy"** — Payment guide\n🤔 **"recommend a tool"** — Get a pick\n📞 **"contact"** — Reach ZYREX\n\nOr just tell me what you're trying to do! 😊`,
    type: "text",
  };
}

// ─── MINI TOOL CARD ───────────────────────────────────────────────────────────
function MiniToolCard({ tool }) {
  const disc = Math.round((1 - tool.price / tool.original) * 100);
  return (
    <div
      style={{
        background: C.surface2,
        border: `1px solid ${C.border}`,
        borderRadius: 10,
        padding: "12px 14px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 1,
          background: `linear-gradient(90deg,transparent,${C.accent}44,transparent)`,
        }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          marginBottom: 8,
        }}
      >
        <span style={{ fontSize: 22 }}>{tool.icon}</span>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: C.text,
              fontFamily: "Orbitron,monospace",
            }}
          >
            {tool.name}
          </div>
          <div
            style={{
              fontSize: 9,
              color: C.muted,
              fontFamily: "JetBrains Mono",
            }}
          >
            {tool.category}
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div
            style={{
              fontFamily: "Orbitron,monospace",
              fontSize: 16,
              fontWeight: 900,
              color: C.accent,
            }}
          >
            ${tool.price}
          </div>
          <div
            style={{
              fontSize: 9,
              color: C.muted,
              textDecoration: "line-through",
            }}
          >
            ${tool.original}
          </div>
        </div>
      </div>
      <div
        style={{
          fontSize: 11,
          color: C.muted,
          lineHeight: 1.5,
          marginBottom: 8,
        }}
      >
        {tool.tagline}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
        {tool.features.slice(0, 3).map((f, i) => (
          <span
            key={i}
            style={{
              background: C.accentDim,
              color: C.accent,
              border: `1px solid ${C.accent}22`,
              fontSize: 9,
              padding: "2px 7px",
              borderRadius: 10,
              fontFamily: "JetBrains Mono",
            }}
          >
            ✓ {f}
          </span>
        ))}
        {disc >= 40 && (
          <span
            style={{
              background: "#34d39911",
              color: "#34d399",
              border: "1px solid #34d39922",
              fontSize: 9,
              padding: "2px 7px",
              borderRadius: 10,
              fontFamily: "JetBrains Mono",
            }}
          >
            {disc}% OFF
          </span>
        )}
      </div>
      {tool.discount && (
        <div
          style={{
            marginTop: 6,
            fontSize: 9,
            color: C.orange,
            fontWeight: 700,
            fontFamily: "JetBrains Mono",
          }}
        >
          🔥 {tool.discount}
        </div>
      )}
      {tool.plans && (
        <div
          style={{
            marginTop: 6,
            fontSize: 9,
            color: C.muted,
            fontFamily: "JetBrains Mono",
          }}
        >
          Plans: {tool.plans.join(" · ")}
        </div>
      )}
    </div>
  );
}

// ─── COMPARE TABLE ────────────────────────────────────────────────────────────
function CompareTable() {
  return (
    <div style={{ overflowX: "auto", marginTop: 8 }}>
      <table
        style={{ width: "100%", borderCollapse: "collapse", fontSize: 10 }}
      >
        <thead>
          <tr>
            {["Tool", "Price", "Off", "Category"].map((h) => (
              <th
                key={h}
                style={{
                  padding: "7px 9px",
                  background: C.surface2,
                  border: `1px solid ${C.border}`,
                  color: C.accent,
                  fontFamily: "JetBrains Mono",
                  fontSize: 8,
                  letterSpacing: "0.1em",
                  textAlign: "left",
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...TOOLS]
            .sort((a, b) => a.price - b.price)
            .map((t, i) => (
              <tr
                key={i}
                style={{ background: i % 2 === 0 ? C.bg : C.surface }}
              >
                <td
                  style={{
                    padding: "7px 9px",
                    border: `1px solid ${C.border}`,
                    color: C.text,
                    fontWeight: 600,
                  }}
                >
                  {t.icon} {t.name}
                </td>
                <td
                  style={{
                    padding: "7px 9px",
                    border: `1px solid ${C.border}`,
                    color: C.accent,
                    fontFamily: "Orbitron,monospace",
                    fontWeight: 700,
                  }}
                >
                  ${t.price}
                </td>
                <td
                  style={{
                    padding: "7px 9px",
                    border: `1px solid ${C.border}`,
                    color: "#34d399",
                    fontSize: 9,
                  }}
                >
                  {Math.round((1 - t.price / t.original) * 100)}%
                </td>
                <td
                  style={{
                    padding: "7px 9px",
                    border: `1px solid ${C.border}`,
                    color: C.muted,
                  }}
                >
                  {t.category}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
export default function AIRexAgent() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [typing, setTyping] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [searchQ, setSearchQ] = useState("");
  const [showPurchase, setShowPurchase] = useState(false);
  const chatRef = useRef(null);
  const inputRef = useRef(null);
  const typingRef = useRef(null);

  useEffect(() => {
    window.__openRexChat     = () => { setOpen(true); setShowPurchase(false); };
    window.__openRexPurchase = () => { setOpen(true); setShowPurchase(true); };
    return () => { delete window.__openRexChat; delete window.__openRexPurchase; };
  }, []);

  useEffect(() => {
    if (chatRef.current)
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [messages, loading, typing]);


  useEffect(
    () => () => {
      if (typingRef.current) clearInterval(typingRef.current);
    },
    [],
  );

  function doReply(msg) {
    const { text, type, tools, tool } = smartReply(msg);
    setLoading(false);

    if (type !== "text") {
      setMessages((prev) => [
        ...prev,
        { role: "assistant", text, type, tools, tool, ts: new Date() },
      ]);
      return;
    }

    let i = 0;
    setTyping("");
    typingRef.current = setInterval(() => {
      i++;
      setTyping(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(typingRef.current);
        setTyping("");
        setMessages((prev) => [
          ...prev,
          { role: "assistant", text, type, ts: new Date() },
        ]);
        }
    }, 7);
  }

  function sendMessage(txt) {
    const msg = (txt || input).trim();
    if (!msg || loading || typing) return;
    setInput("");
    setShowSearch(false);
    setMessages((prev) => [
      ...prev,
      { role: "user", text: msg, type: "text", ts: new Date() },
    ]);
    setLoading(true);
    setTimeout(() => doReply(msg), 400 + Math.random() * 200);
  }

  function handleKey(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  }

  const searchResults =
    searchQ.length > 1
      ? TOOLS.filter(
          (t) =>
            t.name.toLowerCase().includes(searchQ.toLowerCase()) ||
            t.category.toLowerCase().includes(searchQ.toLowerCase()) ||
            t.features.some((f) =>
              f.toLowerCase().includes(searchQ.toLowerCase()),
            ),
        )
      : [];

  // Chat is closed — render nothing (nav AI button is the trigger)
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 9999,
        width: 460,
        maxWidth: "calc(100vw - 16px)",
        height: 680,
        maxHeight: "calc(100vh - 40px)",
        background: "linear-gradient(160deg,#0a0c1e,#060810)",
        border: "1px solid rgba(99,102,241,0.25)",
        borderRadius: 20,
        boxShadow: "0 32px 80px rgba(0,0,0,0.9),0 0 0 1px rgba(99,102,241,0.1) inset,0 0 60px rgba(99,102,241,0.12)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        fontFamily: "Exo 2,Segoe UI,sans-serif",
        backdropFilter: "blur(40px)",
      }}
    >
      <style>{`
        @keyframes rexDot{0%,80%,100%{transform:scale(0.7);opacity:0.3}40%{transform:scale(1.2);opacity:1}}
        @keyframes rexMsg{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
        @keyframes rexSlide{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
        @keyframes aiHeaderGlow{0%,100%{opacity:0.6}50%{opacity:1}}
        .rex-msg{animation:rexMsg 0.25s cubic-bezier(0.16,1,0.3,1)}
        .rex-in:focus{border-color:rgba(99,102,241,0.6)!important;box-shadow:0 0 0 3px rgba(99,102,241,0.1)!important;outline:none}
        .rex-chip:hover{border-color:rgba(99,102,241,0.5)!important;color:#a5b4fc!important;background:rgba(99,102,241,0.1)!important;transform:translateY(-1px)}
        .rex-send:hover{box-shadow:0 0 24px rgba(99,102,241,0.5)!important;transform:translateY(-1px)}
        .rex-send:disabled{opacity:0.3!important;cursor:not-allowed!important}
        .rex-close:hover{color:#f87171!important;background:rgba(248,113,113,0.1)!important}
        .rex-sres:hover{background:rgba(99,102,241,0.08)!important}
        ::-webkit-scrollbar{width:3px}
        ::-webkit-scrollbar-thumb{background:rgba(99,102,241,0.3);border-radius:2px}
      `}</style>

      {/* HEADER */}
      <div
        style={{
          padding: "14px 16px",
          borderBottom: "1px solid rgba(99,102,241,0.15)",
          background: "linear-gradient(135deg,rgba(99,102,241,0.12),rgba(168,85,247,0.08))",
          display: "flex",
          alignItems: "center",
          gap: 12,
          position: "relative",
          flexShrink: 0,
        }}
      >
        {/* animated top border */}
        <div style={{ position:"absolute",top:0,left:0,right:0,height:2,
          background:"linear-gradient(90deg,transparent,#6366f1,#a855f7,#38bdf8,transparent)",
          animation:"aiHeaderGlow 3s ease-in-out infinite" }} />
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            flexShrink: 0,
            background: "linear-gradient(135deg,#6366f1,#a855f7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 18,
            boxShadow: "0 0 20px rgba(99,102,241,0.5)",
          }}
        >
          🤖
        </div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontFamily: "Orbitron,monospace",
              fontSize: 13,
              fontWeight: 900,
              letterSpacing: "0.1em",
              background: "linear-gradient(135deg,#a5b4fc,#e0e7ff)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            AI REX
          </div>
          <div
            style={{
              fontSize: 9,
              color: "rgba(165,180,252,0.6)",
              letterSpacing: "0.08em",
              fontFamily: "JetBrains Mono,monospace",
              display: "flex",
              alignItems: "center",
              gap: 5,
              marginTop: 2,
            }}
          >
            <span style={{ width:5,height:5,borderRadius:"50%",background:"#34d399",
              display:"inline-block",boxShadow:"0 0 6px #34d399",animation:"aiHeaderGlow 2s ease-in-out infinite" }} />
            TOOLREX ASSISTANT · ONLINE · {TOOLS.length} TOOLS
          </div>
        </div>
        {/* Buy button */}
        <button
          onClick={() => { setShowPurchase(true); setShowSearch(false); }}
          title="Buy License"
          style={{
            padding: "6px 12px", borderRadius: 8, fontSize: 10, fontWeight: 800,
            background: "linear-gradient(135deg,#6366f1,#a855f7)",
            border: "none", color: "#fff", cursor: "pointer",
            fontFamily: "Orbitron,monospace", letterSpacing: "0.05em",
            flexShrink: 0,
            boxShadow: "0 0 14px rgba(99,102,241,0.4)",
          }}
        >🛒 BUY</button>
        <button
          onClick={() => setShowSearch(!showSearch)}
          title="Search tools"
          style={{
            width: 28,
            height: 28,
            borderRadius: 6,
            background: showSearch ? C.accentDim : "transparent",
            border: `1px solid ${showSearch ? C.accent : C.border}`,
            color: showSearch ? C.accent : C.muted,
            cursor: "pointer",
            fontSize: 13,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s",
          }}
        >
          🔍
        </button>
        <button
          onClick={() => setMessages([])}
          style={{
            background: "transparent",
            border: `1px solid ${C.border}`,
            borderRadius: 5,
            color: C.muted,
            cursor: "pointer",
            fontSize: 9,
            padding: "3px 7px",
            fontFamily: "JetBrains Mono",
            transition: "color 0.2s",
          }}
          onMouseEnter={(e) => (e.target.style.color = C.gold)}
          onMouseLeave={(e) => (e.target.style.color = C.muted)}
        >
          CLR
        </button>
        <button
          className="rex-close"
          onClick={() => setOpen(false)}
          style={{
            width: 27,
            height: 27,
            borderRadius: 6,
            background: "transparent",
            border: `1px solid ${C.border}`,
            color: C.muted,
            cursor: "pointer",
            fontSize: 13,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "color 0.2s",
            flexShrink: 0,
          }}
        >
          ✕
        </button>
      </div>

      {/* SEARCH BAR */}
      {showSearch && (
        <div
          style={{
            padding: "8px 12px",
            borderBottom: `1px solid ${C.border}`,
            background: C.surface2,
            position: "relative",
          }}
        >
          <input
            value={searchQ}
            onChange={(e) => setSearchQ(e.target.value)}
            placeholder="Search tools by name, category, feature..."
            autoFocus
            style={{
              width: "100%",
              background: C.bg,
              border: `1px solid ${C.border}`,
              borderRadius: 7,
              padding: "7px 11px",
              color: C.text,
              fontFamily: "Exo 2,sans-serif",
              fontSize: 12,
              outline: "none",
              transition: "border 0.2s",
            }}
            onFocus={(e) => (e.target.style.borderColor = C.accent)}
            onBlur={(e) => (e.target.style.borderColor = C.border)}
          />
          {searchResults.length > 0 && (
            <div
              style={{
                position: "absolute",
                left: 12,
                right: 12,
                top: "calc(100% + 2px)",
                background: C.surface,
                border: `1px solid ${C.border}`,
                borderRadius: 8,
                zIndex: 100,
                overflow: "hidden",
                boxShadow: "0 8px 32px rgba(0,0,0,0.6)",
              }}
            >
              {searchResults.map((t) => (
                <div
                  key={t.id}
                  className="rex-sres"
                  onClick={() => {
                    sendMessage(`Tell me about ${t.name}`);
                    setShowSearch(false);
                    setSearchQ("");
                  }}
                  style={{
                    padding: "9px 13px",
                    cursor: "pointer",
                    borderBottom: `1px solid ${C.border}`,
                    display: "flex",
                    alignItems: "center",
                    gap: 9,
                    transition: "background 0.15s",
                  }}
                >
                  <span style={{ fontSize: 18 }}>{t.icon}</span>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, color: C.text }}
                    >
                      {t.name}
                    </div>
                    <div style={{ fontSize: 9, color: C.muted }}>
                      {t.tagline}
                    </div>
                  </div>
                  <div
                    style={{
                      fontFamily: "Orbitron,monospace",
                      fontSize: 12,
                      fontWeight: 700,
                      color: C.accent,
                    }}
                  >
                    ${t.price}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* PURCHASE FLOW OVERLAY */}
      {showPurchase && (
        <PurchaseFlow onClose={() => setShowPurchase(false)} />
      )}

      {/* MESSAGES */}
      <div
        ref={chatRef}
        style={{
          flex: 1,
          overflowY: "auto",
          padding: 14,
          display: "flex",
          flexDirection: "column",
          gap: 13,
        }}
      >
        {messages.length === 0 && !typing && (
          <div style={{ animation: "rexSlide 0.4s ease" }}>
            <div
              style={{
                background: C.surface,
                border: `1px solid ${C.border}`,
                borderRadius: 12,
                padding: "16px 14px",
                marginBottom: 14,
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 1,
                  background:
                    "linear-gradient(90deg,transparent,#38bdf8,transparent)",
                }}
              />
              <div style={{ fontSize: 30, marginBottom: 6 }}>🤖</div>
              <div
                style={{
                  fontFamily: "Orbitron,monospace",
                  fontSize: 13,
                  fontWeight: 800,
                  color: C.accent,
                  marginBottom: 5,
                }}
              >
                Hey! I'm AI Rex
              </div>
              <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.7 }}>
                I know everything about{" "}
                <strong style={{ color: C.text }}>TOOLREX.ONLINE</strong>.<br />
                Search, compare, get recommendations! 😊
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: 6,
                marginBottom: 12,
                justifyContent: "center",
              }}
            >
              {[
                ["8", "Tools"],
                ["$9", "Lowest"],
                ["80%", "Max Off"],
                ["24/7", "Support"],
              ].map(([v, l]) => (
                <div
                  key={l}
                  style={{
                    flex: 1,
                    background: C.surface,
                    border: `1px solid ${C.border}`,
                    borderRadius: 7,
                    padding: "7px 3px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Orbitron,monospace",
                      fontSize: 12,
                      fontWeight: 900,
                      color: C.accent,
                    }}
                  >
                    {v}
                  </div>
                  <div
                    style={{
                      fontSize: 8,
                      color: C.muted,
                      marginTop: 1,
                      fontFamily: "JetBrains Mono",
                    }}
                  >
                    {l}
                  </div>
                </div>
              ))}
            </div>
            <div
              style={{
                fontSize: 8,
                color: C.muted,
                letterSpacing: "0.15em",
                marginBottom: 8,
                fontFamily: "JetBrains Mono",
              }}
            >
              {"// QUICK START"}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
              {QUICK.map((s, i) => (
                <button
                  key={i}
                  className="rex-chip"
                  onClick={() => sendMessage(s.text)}
                  style={{
                    padding: "5px 10px",
                    background: C.surface,
                    border: `1px solid ${C.border}`,
                    borderRadius: 18,
                    color: C.muted,
                    cursor: "pointer",
                    fontSize: 10,
                    fontWeight: 600,
                    transition: "all 0.2s",
                    fontFamily: "Exo 2,sans-serif",
                  }}
                >
                  {s.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {messages.map((msg, i) => (
          <div
            key={i}
            className="rex-msg"
            style={{
              display: "flex",
              flexDirection: msg.role === "user" ? "row-reverse" : "row",
              gap: 9,
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: 6,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 9,
                fontWeight: 800,
                fontFamily: "Orbitron,monospace",
                background:
                  msg.role === "user"
                    ? "rgba(251,146,60,0.1)"
                    : "rgba(56,189,248,0.1)",
                border: `1px solid ${msg.role === "user" ? "rgba(251,146,60,0.3)" : "rgba(56,189,248,0.3)"}`,
                color: msg.role === "user" ? C.orange : C.accent,
              }}
            >
              {msg.role === "user" ? "U" : "RX"}
            </div>
            <div style={{ maxWidth: "82%", minWidth: 0 }}>
              <div
                style={{
                  fontSize: 8,
                  color: C.muted,
                  letterSpacing: "0.1em",
                  marginBottom: 3,
                  fontFamily: "JetBrains Mono",
                  textAlign: msg.role === "user" ? "right" : "left",
                }}
              >
                {msg.role === "user" ? "YOU" : "AI REX"} ·{" "}
                {msg.ts?.toLocaleTimeString("en-US", {
                  hour12: false,
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
              <div
                style={{
                  padding: "9px 12px",
                  background:
                    msg.role === "user" ? "rgba(251,146,60,0.06)" : C.surface,
                  border: `1px solid ${msg.role === "user" ? "rgba(251,146,60,0.2)" : C.border}`,
                  borderRadius:
                    msg.role === "user"
                      ? "11px 3px 11px 11px"
                      : "3px 11px 11px 11px",
                  fontSize: 12,
                  lineHeight: 1.65,
                  color: C.text,
                  wordBreak: "break-word",
                }}
              >
                <RenderText text={msg.text} />
              </div>
              {msg.type === "tools" && msg.tools && (
                <div
                  style={{
                    marginTop: 7,
                    display: "flex",
                    flexDirection: "column",
                    gap: 7,
                  }}
                >
                  {msg.tools.map((t) => (
                    <MiniToolCard key={t.id} tool={t} />
                  ))}
                </div>
              )}
              {msg.type === "tool" && msg.tool && (
                <div style={{ marginTop: 7 }}>
                  <MiniToolCard tool={msg.tool} />
                </div>
              )}
              {msg.type === "compare" && (
                <div style={{ marginTop: 7 }}>
                  <CompareTable />
                </div>
              )}
            </div>
          </div>
        ))}

        {typing && (
          <div
            className="rex-msg"
            style={{ display: "flex", gap: 9, alignItems: "flex-start" }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: 6,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 9,
                fontWeight: 800,
                fontFamily: "Orbitron,monospace",
                background: "rgba(56,189,248,0.1)",
                border: "1px solid rgba(56,189,248,0.3)",
                color: C.accent,
              }}
            >
              RX
            </div>
            <div style={{ maxWidth: "82%" }}>
              <div
                style={{
                  fontSize: 8,
                  color: C.muted,
                  letterSpacing: "0.1em",
                  marginBottom: 3,
                  fontFamily: "JetBrains Mono",
                }}
              >
                AI REX · typing...
              </div>
              <div
                style={{
                  padding: "9px 12px",
                  background: C.surface,
                  border: `1px solid ${C.border}`,
                  borderRadius: "3px 11px 11px 11px",
                  fontSize: 12,
                  lineHeight: 1.65,
                  color: C.text,
                }}
              >
                <RenderText text={typing} />
                <span
                  style={{
                    display: "inline-block",
                    width: 7,
                    height: 12,
                    background: C.accent,
                    marginLeft: 2,
                    verticalAlign: "middle",
                    borderRadius: 1,
                    animation: "rexDot 0.8s ease-in-out infinite",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {loading && !typing && (
          <div className="rex-msg" style={{ display: "flex", gap: 9 }}>
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: 6,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 9,
                fontWeight: 800,
                fontFamily: "Orbitron,monospace",
                background: "rgba(56,189,248,0.1)",
                border: "1px solid rgba(56,189,248,0.3)",
                color: C.accent,
              }}
            >
              RX
            </div>
            <div
              style={{
                padding: "11px 14px",
                background: C.surface,
                border: `1px solid ${C.border}`,
                borderRadius: "3px 11px 11px 11px",
                display: "flex",
                gap: 5,
                alignItems: "center",
              }}
            >
              {[0, 0.2, 0.4].map((d, i) => (
                <span
                  key={i}
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: C.accent,
                    display: "inline-block",
                    animation: `rexDot 1.2s ease-in-out ${d}s infinite`,
                  }}
                />
              ))}
            </div>
          </div>
        )}
      </div>

      {/* INPUT */}
      <div
        style={{
          padding: "10px 12px",
          borderTop: "1px solid rgba(99,102,241,0.15)",
          background: "rgba(99,102,241,0.04)",
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
          <textarea
            ref={inputRef}
            className="rex-in"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKey}
            onInput={(e) => {
              e.target.style.height = "auto";
              e.target.style.height =
                Math.min(e.target.scrollHeight, 110) + "px";
            }}
            placeholder="Ask anything — tools, prices, coding..."
            rows={1}
            style={{
              flex: 1,
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(99,102,241,0.2)",
              borderRadius: 10,
              padding: "9px 13px",
              color: C.text,
              fontFamily: "Exo 2,sans-serif",
              fontSize: 12,
              resize: "none",
              minHeight: 38,
              maxHeight: 110,
              transition: "border 0.2s,box-shadow 0.2s",
              lineHeight: 1.5,
            }}
          />
          <button
            className="rex-send"
            onClick={() => sendMessage()}
            disabled={loading || !!typing || !input.trim()}
            style={{
              width: 38,
              height: 38,
              borderRadius: 10,
              flexShrink: 0,
              background: "linear-gradient(135deg,#6366f1,#a855f7)",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              fontSize: 13,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s",
              boxShadow: "0 0 16px rgba(99,102,241,0.4)",
            }}
          >
            ▶
          </button>
        </div>
        <div
          style={{
            fontSize: 8,
            color: C.muted,
            marginTop: 5,
            fontFamily: "JetBrains Mono",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>Enter send · Shift+Enter new line · 🔍 to search</span>
          <span style={{ color: C.accent + "55" }}>TOOLREX.ONLINE</span>
        </div>
      </div>
    </div>
  );
}

function RenderText({ text }) {
  const lines = text.split("\n");
  const els = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (line.match(/\*\*(.*?)\*\*/)) {
      els.push(
        <div key={i} style={{ marginTop: i > 0 ? 6 : 0, marginBottom: 2 }}>
          {inl(line)}
        </div>,
      );
      i++;
      continue;
    }
    if (line.trim().startsWith("- ") || line.trim().startsWith("* ")) {
      els.push(
        <div
          key={i}
          style={{ display: "flex", gap: 6, paddingLeft: 3, marginTop: 2 }}
        >
          <span style={{ color: "#38bdf8", flexShrink: 0 }}>·</span>
          <span style={{ fontSize: 12 }}>{inl(line.trim().slice(2))}</span>
        </div>,
      );
      i++;
      continue;
    }
    if (line.match(/^\d+\.\s/)) {
      els.push(
        <div
          key={i}
          style={{ display: "flex", gap: 6, paddingLeft: 3, marginTop: 2 }}
        >
          <span
            style={{
              color: "#38bdf8",
              flexShrink: 0,
              fontSize: 10,
              fontFamily: "JetBrains Mono",
            }}
          >
            {line.match(/^\d+/)[0]}.
          </span>
          <span style={{ fontSize: 12 }}>
            {inl(line.replace(/^\d+\.\s/, ""))}
          </span>
        </div>,
      );
      i++;
      continue;
    }
    if (line.trim() === "") {
      els.push(<div key={i} style={{ height: 4 }} />);
      i++;
      continue;
    }
    els.push(
      <div key={i} style={{ fontSize: 12, lineHeight: 1.65 }}>
        {inl(line)}
      </div>,
    );
    i++;
  }
  return <div>{els}</div>;
}

// ═══════════════════════════════════════════════════════════════════════════
//  PURCHASE FLOW — ABA PayWay → Bill Verify → License Key → Rules
// ═══════════════════════════════════════════════════════════════════════════

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

const PRICING = {
  "EMrex":          { monthly: 1,  yearly: 5,  lifetime: 10 },
  "DL REX":         { monthly: 2,  yearly: 7,  lifetime: 9.99 },
  "AutoFlow AI":    { monthly: 5,  yearly: 20, lifetime: 29 },
  "PromptCraft Pro":{ monthly: 4,  yearly: 15, lifetime: 19 },
  "DataPulse":      { monthly: 4,  yearly: 18, lifetime: 24 },
  "LinkVault":      { monthly: 2,  yearly: 8,  lifetime: 12 },
  "SecureVault":    { monthly: 2,  yearly: 6,  lifetime: 9 },
  "WriteBoost":     { monthly: 3,  yearly: 10, lifetime: 15 },
};

const TOOLREX_RULES = [
  "WE DON'T WARRANTY ON YOUR KEY",
  "DON'T RESELL YOUR KEY",
  "DON'T GIVE YOUR KEY TO SOMEONE ELSE",
  "DON'T BYPASS OR CRACK THE KEY SYSTEM",
  "DON'T COPY OR REDISTRIBUTE THE SOFTWARE",
  "ONE KEY = ONE DEVICE ONLY",
  "LOST KEYS CANNOT BE RECOVERED — KEEP IT SAFE",
  "DON'T SHARE YOUR LICENSE PUBLICLY",
  "REPORT ISSUES TO SUPPORT WITHIN 24 HOURS",
  "VIOLATION OF RULES RESULTS IN IMMEDIATE KEY REVOCATION",
];

const DURATION_LABELS = {
  monthly: "1 Month",
  yearly:  "1 Year",
  lifetime:"Lifetime",
};

async function apiPurchaseStart(tool, duration) {
  const res = await fetch(`${API_BASE}/purchase/start`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tool, duration, customer: "Website Customer" }),
  });
  if (!res.ok) throw new Error((await res.json()).detail || "Server error");
  return res.json();
}

async function apiVerifyBill(sessionId, billId) {
  const res = await fetch(`${API_BASE}/purchase/verify-bill`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, bill_id: billId }),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.detail || "Server error");
  return json;
}

async function apiPurchaseDemo(tool, duration) {
  const res = await fetch(`${API_BASE}/purchase/demo`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tool, duration, customer: "Demo Customer" }),
  });
  if (!res.ok) throw new Error((await res.json()).detail || "Demo error");
  return res.json();
}

async function apiGenerateDeviceKey(sessionId, deviceId) {
  const res = await fetch(`${API_BASE}/purchase/generate-device-key`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, device_id: deviceId }),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.detail || "Server error");
  return json;
}

function PurchaseFlow({ onClose }) {
  const [step, setStep] = useState("tool");    // tool|duration|payment|bill|verifying|rules|download|device_id|final_key
  const [selectedTool, setSelectedTool] = useState(null);
  const [selectedDur, setSelectedDur]   = useState(null);
  const [sessionData, setSessionData]   = useState(null);
  const [demoMode, setDemoMode]         = useState(false);
  const [billId, setBillId]             = useState("");
  const [error, setError]               = useState("");
  // Ref ensures verify always gets the latest sessionId even after async demo setup
  const sessionRef = useRef(null);
  const [loading, setLoading]           = useState(false);
  const [keyCopied, setKeyCopied]       = useState(false);
  const [ruleIdx, setRuleIdx]           = useState(0);
  const [deviceId, setDeviceId]         = useState("");
  const [keyData, setKeyData]           = useState(null);
  const [downloaded, setDownloaded]     = useState(false);

  async function handleDurationSelect(dur) {
    setSelectedDur(dur); setError(""); setLoading(true);
    try {
      const data = await apiPurchaseStart(selectedTool.name, dur);
      sessionRef.current = data.session_id;
      setSessionData(data); setStep("payment");
    } catch(e) { setError(e.message); }
    setLoading(false);
  }

  async function handleVerifyBill() {
    const sid = sessionRef.current;
    const bid = billId.trim();
    if (!bid || bid.length < 10) {
      setError("Please enter a valid Transaction ID (min 10 characters)"); return;
    }
    if (!sid) {
      setError("Session expired. Please start over."); return;
    }
    setError(""); setStep("verifying"); setLoading(true);
    try {
      await apiVerifyBill(sid, bid);
      setStep("rules");
    } catch(e) {
      const msg = e.message;
      if (msg === "BILL_NOT_FOUND") {
        setError("❌ Bill ID not found. Your payment may not have arrived yet, or the ID is wrong.\n\nContact support with your bill screenshot.");
      } else if (msg === "BILL_ALREADY_USED") {
        setError("⚠️ This bill has already been used for another purchase.");
      } else {
        setError(msg);
      }
      setStep("bill");
    }
    setLoading(false);
  }

  async function handleGenerateKey() {
    const sid = sessionRef.current;
    const did = deviceId.trim().toUpperCase();
    if (!did.match(/^DEV-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/)) {
      setError("Invalid Device ID format. Must be DEV-XXXX-XXXX-XXXX (e.g. DEV-2701-A19D-26F2)"); return;
    }
    if (!sid) { setError("Session expired. Please start over."); return; }
    setError(""); setLoading(true);
    try {
      const data = await apiGenerateDeviceKey(sid, did);
      setKeyData(data); setStep("final_key");
    } catch(e) { setError(e.message); }
    setLoading(false);
  }

  async function downloadTool() {
    const sid = sessionRef.current;
    if (!sid || !selectedTool) return;
    setError(""); setLoading(true);
    try {
      const url = `${API_BASE}/purchase/download/${encodeURIComponent(selectedTool.name)}?session_id=${encodeURIComponent(sid)}`;
      const res = await fetch(url);
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        setError(err.detail || "Download not available. Contact support via Telegram.");
        setLoading(false); return;
      }
      const blob = await res.blob();
      const burl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = burl; a.download = `${selectedTool.name}.zip`;
      document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(burl);
      setDownloaded(true);
    } catch(e) {
      setError("Download failed. Contact support via Telegram.");
    }
    setLoading(false);
  }

  function downloadToolkey() {
    const sid = sessionRef.current;
    if (!sid) return;
    const url = `${API_BASE}/purchase/toolkey/${encodeURIComponent(sid)}`;
    const a = document.createElement("a");
    a.href = url; a.download = "toolkey.zip";
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
  }

  function copyFinalKey() {
    if (!keyData?.license_key) return;
    navigator.clipboard.writeText(keyData.license_key).then(() => {
      setKeyCopied(true); setTimeout(() => setKeyCopied(false), 2500);
    });
  }

  const cardStyle = {
    background: "rgba(14,21,37,0.98)",
    border: `1px solid ${C.border}`,
    borderRadius: 12, padding: "14px 16px",
    cursor: "pointer", transition: "all 0.2s",
    position: "relative", overflow: "hidden",
  };

  return (
    <div style={{
      position: "absolute", inset: 0, zIndex: 100,
      background: "linear-gradient(160deg, #05080f, #0a1628)",
      borderRadius: 16, display: "flex", flexDirection: "column",
      overflow: "hidden",
    }}>
      {/* Header */}
      <div style={{
        padding: "14px 18px", borderBottom: `1px solid ${C.border}`,
        display: "flex", alignItems: "center", gap: 10,
        background: "rgba(0,0,0,0.3)",
      }}>
        <div style={{
          width: 8, height: 8, borderRadius: "50%",
          background: "linear-gradient(135deg,#38bdf8,#7c3aed)",
          animation: "urgentPulse 2s infinite",
        }} />
        <span style={{ flex: 1, fontSize: 13, fontWeight: 800, color: C.accent,
          fontFamily: "Orbitron,monospace", letterSpacing: "0.08em" }}>
          PURCHASE LICENSE
        </span>
        {!["rules","download","device_id","final_key"].includes(step) && (
          <button onClick={onClose} style={{
            background: "transparent", border: `1px solid ${C.border}`,
            borderRadius: 6, color: C.muted, cursor: "pointer",
            width: 26, height: 26, fontSize: 12,
          }}>✕</button>
        )}
      </div>

      {/* Step indicator */}
      {step !== "final_key" && (
        <div style={{ display: "flex", padding: "10px 18px", gap: 4, borderBottom: `1px solid ${C.border}22`, alignItems: "center" }}>
          {[["Tool",0],["Pay",1],["Verify",2],["Setup",3]].map(([label, phase], i) => {
            const phaseOf = {tool:0,duration:1,payment:1,bill:2,verifying:2,rules:3,download:3,device_id:3};
            const curPhase = phaseOf[step] ?? 0;
            const done = curPhase > phase;
            const active = curPhase === phase;
            return (
              <div key={label} style={{ flex: 1, display: "flex", alignItems: "center", gap: 4 }}>
                <div style={{
                  width: 20, height: 20, borderRadius: "50%", fontSize: 9, fontWeight: 800,
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                  background: done ? C.green : active ? C.accent : C.border,
                  color: done || active ? "#05080f" : C.muted,
                  transition: "all 0.3s",
                }}>{done ? "✓" : phase + 1}</div>
                <div style={{ fontSize: 8, color: active ? C.accent : done ? C.green : C.muted,
                  fontFamily: "JetBrains Mono", whiteSpace: "nowrap" }}>{label}</div>
                {i < 3 && <div style={{ flex: 1, height: 2, background: done ? C.green : C.border, transition: "all 0.3s" }} />}
              </div>
            );
          })}
        </div>
      )}

      {/* Body */}
      <div style={{ flex: 1, overflowY: "auto", padding: "16px 18px" }}>

        {error && (
          <div style={{
            background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.25)",
            borderRadius: 10, padding: "12px 14px", marginBottom: 14,
            color: "#f87171", fontSize: 12, lineHeight: 1.7, whiteSpace: "pre-line",
          }}>
            {error}
            <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
              <a href="https://t.me/zyrexdev_official" target="_blank" rel="noreferrer">
                <button style={{
                  background: "#229ED9", border: "none", borderRadius: 6,
                  padding: "6px 12px", color: "#fff", fontSize: 11, cursor: "pointer", fontWeight: 700,
                }}>✈ Contact Support</button>
              </a>
            </div>
          </div>
        )}

        {/* STEP 1 — Select Tool */}
        {step === "tool" && (
          <div>
            <div style={{ fontSize: 13, fontWeight: 800, color: C.text, marginBottom: 4 }}>Choose a Tool</div>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 14 }}>Select the tool you want to license</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {TOOLS.map(t => (
                <div key={t.id} style={cardStyle}
                  onClick={() => { setSelectedTool(t); setStep("duration"); setError(""); }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = C.accent}
                  onMouseLeave={e => e.currentTarget.style.borderColor = C.border}
                >
                  <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2,
                    background: "linear-gradient(90deg,transparent,#38bdf822,transparent)" }} />
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ fontSize: 22 }}>{t.icon}</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>{t.name}</div>
                      <div style={{ fontSize: 10, color: C.muted }}>{t.tagline}</div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontSize: 14, fontWeight: 900, color: C.accent,
                        fontFamily: "Orbitron,monospace" }}>${PRICING[t.name]?.lifetime ?? t.price}</div>
                      <div style={{ fontSize: 9, color: C.muted }}>lifetime</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* STEP 2 — Select Duration */}
        {step === "duration" && selectedTool && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
              <span style={{ fontSize: 20 }}>{selectedTool.icon}</span>
              <div style={{ fontSize: 13, fontWeight: 800, color: C.text }}>{selectedTool.name}</div>
            </div>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 16 }}>Choose your license duration</div>
            {loading ? (
              <div style={{ textAlign: "center", padding: 32, color: C.muted }}>
                <div style={{ fontSize: 24, marginBottom: 8 }}>⏳</div>Creating order...
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {["monthly","yearly","lifetime"].map(dur => {
                  const price = PRICING[selectedTool.name]?.[dur] ?? "—";
                  const badges = { lifetime: "BEST DEAL", yearly: "POPULAR", monthly: "" };
                  return (
                    <div key={dur} style={{ ...cardStyle, border: `1px solid ${dur==="lifetime"?"#fb923c44":C.border}` }}
                      onClick={() => handleDurationSelect(dur)}
                      onMouseEnter={e => e.currentTarget.style.borderColor = dur==="lifetime"?"#fb923c":C.accent}
                      onMouseLeave={e => e.currentTarget.style.borderColor = dur==="lifetime"?"#fb923c44":C.border}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>
                            {DURATION_LABELS[dur]}
                          </div>
                          <div style={{ fontSize: 10, color: C.muted }}>
                            {dur === "lifetime" ? "Pay once, own forever" :
                             dur === "yearly"   ? "Billed annually" : "Billed monthly"}
                          </div>
                        </div>
                        {badges[dur] && (
                          <span style={{ fontSize: 9, fontWeight: 800, padding: "3px 7px",
                            borderRadius: 4, background: dur==="lifetime"?"#fb923c22":"#38bdf811",
                            color: dur==="lifetime"?"#fb923c":C.accent, letterSpacing: "0.06em" }}>
                            {badges[dur]}
                          </span>
                        )}
                        <div style={{ fontFamily: "Orbitron,monospace", fontSize: 16,
                          fontWeight: 900, color: C.accent }}>${price}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <button onClick={() => { setStep("tool"); setError(""); }} style={{
              marginTop: 14, background: "none", border: "none",
              color: C.muted, cursor: "pointer", fontSize: 11,
            }}>← Back to tools</button>
          </div>
        )}

        {/* STEP 3 — ABA Payment */}
        {step === "payment" && sessionData && (
          <div>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🏦</div>
              <div style={{ fontSize: 14, fontWeight: 800, color: C.text, marginBottom: 4 }}>
                Pay via ABA PayWay
              </div>
              <div style={{ fontSize: 11, color: C.muted }}>
                {selectedTool?.name} · {DURATION_LABELS[selectedDur]}
              </div>
            </div>

            {/* Amount box */}
            <div style={{
              background: "rgba(56,189,248,0.06)", border: "1px solid rgba(56,189,248,0.25)",
              borderRadius: 12, padding: "20px", textAlign: "center", marginBottom: 16,
            }}>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.08em" }}>
                EXACT AMOUNT TO PAY
              </div>
              <div style={{ fontSize: 40, fontWeight: 900, color: C.accent,
                fontFamily: "Orbitron,monospace" }}>${sessionData.price.toFixed(2)}</div>
              <div style={{ fontSize: 10, color: C.muted, marginTop: 4 }}>USD</div>
            </div>

            {/* Instructions */}
            <div style={{
              background: C.surface, border: `1px solid ${C.border}`,
              borderRadius: 10, padding: "14px", marginBottom: 14, fontSize: 12,
            }}>
              <div style={{ fontWeight: 700, color: C.text, marginBottom: 8 }}>How to pay:</div>
              {[
                `1. Click the ABA Pay button below`,
                `2. Pay exactly $${sessionData.price.toFixed(2)} USD`,
                `3. Screenshot your receipt`,
                `4. Note your Transaction ID (long number on receipt)`,
                `5. Click "I've Paid" and enter your Transaction ID`,
              ].map((step, i) => (
                <div key={i} style={{ color: C.muted, marginBottom: 4, lineHeight: 1.6 }}>{step}</div>
              ))}
            </div>

            <a href={sessionData.aba_link} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
              <button style={{
                width: "100%", padding: "14px", marginBottom: 10,
                background: "linear-gradient(135deg,#003087,#009fda)",
                border: "none", borderRadius: 10, color: "#fff",
                fontSize: 14, fontWeight: 800, cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
              }}>
                🏦 Pay with ABA PayWay — ${sessionData.price.toFixed(2)}
              </button>
            </a>
            <button onClick={() => setStep("bill")} style={{
              width: "100%", padding: "12px", marginBottom: 8,
              background: "transparent", border: `1px solid ${C.green}44`,
              borderRadius: 10, color: C.green, fontSize: 13, fontWeight: 700,
              cursor: "pointer",
            }}>
              ✅ I've Paid — Enter Transaction ID
            </button>

            {/* Demo separator */}
            <div style={{ display:"flex", alignItems:"center", gap:8, margin:"6px 0" }}>
              <div style={{ flex:1, height:1, background: C.border }} />
              <span style={{ fontSize:10, color: C.muted, whiteSpace:"nowrap" }}>or try demo</span>
              <div style={{ flex:1, height:1, background: C.border }} />
            </div>

            <button
              onClick={async () => {
                setError(""); setLoading(true);
                try {
                  const d = await apiPurchaseDemo(selectedTool.name, selectedDur);
                  sessionRef.current = d.session_id;
                  setSessionData(prev => ({ ...prev, session_id: d.session_id }));
                  setBillId(d.demo_bill_id);
                  setDemoMode(true);
                  setStep("bill");
                } catch(e) { setError(e.message); }
                setLoading(false);
              }}
              disabled={loading}
              style={{
                width: "100%", padding: "11px",
                background: "rgba(124,58,237,0.12)",
                border: "1px solid rgba(124,58,237,0.35)",
                borderRadius: 10, color: "#a78bfa",
                fontSize: 12, fontWeight: 700, cursor: "pointer",
                display: "flex", alignItems:"center", justifyContent:"center", gap: 8,
              }}
            >
              🎮 {loading ? "Creating demo..." : "Try Demo Flow (no real payment)"}
            </button>
          </div>
        )}

        {/* STEP 4 — Enter Bill ID */}
        {step === "bill" && (
          <div>
            {demoMode && (
              <div style={{
                background: "rgba(124,58,237,0.1)", border: "1px solid rgba(124,58,237,0.35)",
                borderRadius: 10, padding: "10px 14px", marginBottom: 14,
                display: "flex", alignItems: "center", gap: 10,
              }}>
                <span style={{ fontSize: 18 }}>🎮</span>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 800, color: "#a78bfa" }}>Demo Mode</div>
                  <div style={{ fontSize: 11, color: C.muted }}>Bill ID pre-filled — click Verify to get a demo key</div>
                </div>
              </div>
            )}
            <div style={{ textAlign: "center", marginBottom: 16 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🧾</div>
              <div style={{ fontSize: 13, fontWeight: 800, color: C.text, marginBottom: 4 }}>
                Drop Your Bill
              </div>
              <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.7 }}>
                Enter the <span style={{ color: C.accent, fontWeight: 700 }}>Transaction ID</span> from
                your ABA PayWay receipt.<br/>
                Example: <span style={{ fontFamily: "monospace", color: C.muted }}>177769514234376</span>
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: C.muted, letterSpacing: "0.08em",
                textTransform: "uppercase", marginBottom: 6 }}>Transaction / Bill ID</div>
              <input
                value={billId}
                onChange={e => setBillId(e.target.value.trim())}
                placeholder="e.g. 177769514234376"
                maxLength={20}
                style={{
                  width: "100%", background: "rgba(255,255,255,0.03)",
                  border: `1px solid ${billId.length >= 10 ? C.green + "66" : C.border}`,
                  borderRadius: 10, padding: "13px 16px", color: C.text, fontSize: 16,
                  fontFamily: "JetBrains Mono,monospace", letterSpacing: 2,
                  outline: "none", boxSizing: "border-box",
                  transition: "border-color 0.2s",
                  boxShadow: billId.length >= 10 ? `0 0 16px ${C.green}22` : "none",
                }}
                onKeyDown={e => e.key === "Enter" && handleVerifyBill()}
              />
              <div style={{ fontSize: 10, color: C.muted, marginTop: 5 }}>
                {billId.length} chars {billId.length >= 10 ? "✓ ready" : `— need ${10 - billId.length} more`}
              </div>
            </div>
            <button
              onClick={handleVerifyBill}
              disabled={billId.length < 10}
              style={{
                width: "100%", padding: "14px",
                background: billId.length >= 10
                  ? "linear-gradient(135deg,#38bdf8,#7c3aed)"
                  : "rgba(255,255,255,0.04)",
                border: "none", borderRadius: 10,
                color: billId.length >= 10 ? "#fff" : C.muted,
                fontSize: 14, fontWeight: 800,
                cursor: billId.length >= 10 ? "pointer" : "not-allowed",
                transition: "all 0.25s", marginBottom: 10,
              }}
            >
              🔍 Verify Bill & Get License Key
            </button>
            <button onClick={() => setStep("payment")} style={{
              background: "none", border: "none", color: C.muted,
              cursor: "pointer", fontSize: 11, width: "100%",
            }}>← Back to payment</button>
          </div>
        )}

        {/* STEP 4b — Verifying */}
        {step === "verifying" && (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>🔍</div>
            <div style={{ fontSize: 14, fontWeight: 800, color: C.text, marginBottom: 8 }}>
              Verifying Your Bill...
            </div>
            <div style={{ fontSize: 12, color: C.muted, lineHeight: 1.7, marginBottom: 24 }}>
              Checking your Transaction ID<br/>
              against our payment records
            </div>
            <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
              {[0,1,2].map(i => (
                <div key={i} style={{
                  width: 8, height: 8, borderRadius: "50%",
                  background: C.accent, opacity: 0.4,
                  animation: `pulse 1s ease-in-out ${i * 0.25}s infinite`,
                }} />
              ))}
            </div>
          </div>
        )}

        {/* STEP 5 — Download Tool */}
        {step === "download" && (
          <div>
            {demoMode && (
              <div style={{
                background: "rgba(124,58,237,0.1)", border: "1px solid rgba(124,58,237,0.35)",
                borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 11,
                color: "#a78bfa", display: "flex", alignItems: "center", gap: 6,
              }}>
                🎮 <strong>Demo Mode</strong> — Full download flow
              </div>
            )}
            <div style={{ textAlign: "center", marginBottom: 16 }}>
              <div style={{ fontSize: 36, marginBottom: 8 }}>📦</div>
              <div style={{ fontSize: 14, fontWeight: 800, color: C.green, marginBottom: 4 }}>
                Payment Verified!
              </div>
              <div style={{ fontSize: 11, color: C.muted }}>
                Download <strong style={{ color: C.text }}>{selectedTool?.name}</strong> — {DURATION_LABELS[selectedDur]}
              </div>
            </div>

            {/* Tool features */}
            <div style={{
              background: C.surface, border: `1px solid ${C.border}`,
              borderRadius: 10, padding: "14px", marginBottom: 14,
            }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: C.accent, marginBottom: 8, letterSpacing: "0.06em" }}>
                {selectedTool?.icon} WHAT {selectedTool?.name?.toUpperCase()} CAN DO:
              </div>
              {selectedTool?.features?.map((f, i) => (
                <div key={i} style={{ display: "flex", gap: 8, marginBottom: 5, alignItems: "center" }}>
                  <span style={{ color: C.green, fontSize: 10, flexShrink: 0 }}>✓</span>
                  <span style={{ fontSize: 11, color: C.text }}>{f}</span>
                </div>
              ))}
              <div style={{ marginTop: 10, fontSize: 10, color: C.muted, fontStyle: "italic" }}>
                Best for: {selectedTool?.best}
              </div>
            </div>

            <button onClick={downloadTool} disabled={loading} style={{
              width: "100%", padding: "14px", marginBottom: 10,
              background: downloaded
                ? `${C.green}22` : loading
                ? "rgba(255,255,255,0.04)" : "linear-gradient(135deg,#38bdf8,#34d399)",
              border: downloaded ? `1px solid ${C.green}` : "none",
              borderRadius: 10, color: downloaded ? C.green : loading ? C.muted : "#05080f",
              fontSize: 14, fontWeight: 800,
              cursor: loading ? "not-allowed" : "pointer", transition: "all 0.25s",
              display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
            }}>
              {loading ? "⏳ Downloading..." : downloaded ? "✅ Downloaded!" : `⬇ Download ${selectedTool?.name}.zip`}
            </button>

            <div style={{ fontSize: 10, color: C.muted, textAlign: "center", marginBottom: 14 }}>
              After downloading, open the tool to find your <strong style={{ color: C.accent }}>Device ID</strong>
            </div>

            <button onClick={() => setStep("device_id")} style={{
              width: "100%", padding: "13px",
              background: "linear-gradient(135deg,#7c3aed,#38bdf8)",
              border: "none", borderRadius: 10, color: "#fff",
              fontSize: 13, fontWeight: 800, cursor: "pointer",
            }}>
              I've Downloaded — Enter Device ID →
            </button>
          </div>
        )}

        {/* STEP 6 — Device ID */}
        {step === "device_id" && (
          <div>
            <div style={{ textAlign: "center", marginBottom: 16 }}>
              <div style={{ fontSize: 36, marginBottom: 8 }}>🖥️</div>
              <div style={{ fontSize: 14, fontWeight: 800, color: C.text, marginBottom: 4 }}>
                Enter Your Device ID
              </div>
              <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.7 }}>
                Open <strong style={{ color: C.accent }}>{selectedTool?.name}</strong>, copy the<br/>
                Device ID shown in the app and paste it below
              </div>
            </div>

            {/* Instructions box */}
            <div style={{
              background: "rgba(56,189,248,0.06)", border: "1px solid rgba(56,189,248,0.2)",
              borderRadius: 10, padding: "12px 14px", marginBottom: 14,
            }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: C.accent, marginBottom: 6 }}>HOW TO FIND DEVICE ID:</div>
              {["1. Open the downloaded tool", "2. Look for \"Device ID\" or \"Copy ID\" button", "3. Copy the ID (format: DEV-XXXX-XXXX-XXXX)", "4. Paste it below"].map((s, i) => (
                <div key={i} style={{ fontSize: 11, color: C.muted, marginBottom: 3 }}>{s}</div>
              ))}
              <div style={{
                marginTop: 10, fontFamily: "JetBrains Mono,monospace", fontSize: 12,
                color: C.green, letterSpacing: 2, textAlign: "center",
              }}>DEV-XXXX-XXXX-XXXX</div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: C.muted, letterSpacing: "0.08em",
                textTransform: "uppercase", marginBottom: 6 }}>Device ID</div>
              <input
                value={deviceId}
                onChange={e => setDeviceId(e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, ""))}
                placeholder="DEV-XXXX-XXXX-XXXX"
                maxLength={18}
                style={{
                  width: "100%", background: "rgba(255,255,255,0.03)",
                  border: `1px solid ${deviceId.match(/^DEV-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/) ? C.green + "66" : C.border}`,
                  borderRadius: 10, padding: "13px 16px", color: C.text, fontSize: 15,
                  fontFamily: "JetBrains Mono,monospace", letterSpacing: 2,
                  outline: "none", boxSizing: "border-box", transition: "border-color 0.2s",
                }}
                onKeyDown={e => e.key === "Enter" && handleGenerateKey()}
              />
              <div style={{ fontSize: 10, color: C.muted, marginTop: 5 }}>
                {deviceId.match(/^DEV-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/) ? "✓ Valid format" : "Format: DEV-XXXX-XXXX-XXXX"}
              </div>
            </div>

            {loading ? (
              <div style={{ textAlign: "center", padding: 24, color: C.muted }}>
                <div style={{ fontSize: 24, marginBottom: 8 }}>⚙️</div>Generating your key...
              </div>
            ) : (
              <button
                onClick={handleGenerateKey}
                disabled={!deviceId.match(/^DEV-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/)}
                style={{
                  width: "100%", padding: "14px",
                  background: deviceId.match(/^DEV-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/)
                    ? "linear-gradient(135deg,#38bdf8,#7c3aed)"
                    : "rgba(255,255,255,0.04)",
                  border: "none", borderRadius: 10,
                  color: deviceId.match(/^DEV-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/) ? "#fff" : C.muted,
                  fontSize: 14, fontWeight: 800,
                  cursor: deviceId.match(/^DEV-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/) ? "pointer" : "not-allowed",
                  transition: "all 0.25s",
                }}
              >
                🔑 Generate My License Key
              </button>
            )}
            <button onClick={() => setStep("download")} style={{
              marginTop: 10, background: "none", border: "none",
              color: C.muted, cursor: "pointer", fontSize: 11, width: "100%",
            }}>← Back to download</button>
          </div>
        )}

        {/* STEP 7 — Final Key */}
        {step === "final_key" && (
          <div>
            {demoMode && (
              <div style={{
                background: "rgba(124,58,237,0.08)", border: "1px solid rgba(124,58,237,0.25)",
                borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 11,
                color: "#a78bfa", display: "flex", alignItems: "center", gap: 6,
              }}>
                🎮 <strong>Demo Key</strong> — Real key generated for demo
              </div>
            )}
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <div style={{ fontSize: 40, marginBottom: 8 }}>🎉</div>
              <div style={{ fontSize: 14, fontWeight: 800, color: C.green, marginBottom: 4 }}>
                Your License Key is Ready!
              </div>
              <div style={{ fontSize: 11, color: C.muted }}>
                <strong style={{ color: C.text }}>{keyData?.tool}</strong> · {DURATION_LABELS[selectedDur]}
              </div>
            </div>

            {/* Key display */}
            <div style={{
              background: "rgba(52,211,153,0.06)", border: "1px solid rgba(52,211,153,0.3)",
              borderRadius: 12, padding: "20px", marginBottom: 10, textAlign: "center",
            }}>
              <div style={{ fontSize: 10, color: C.muted, marginBottom: 10, letterSpacing: "0.1em" }}>
                LICENSE KEY — {DURATION_LABELS[selectedDur]?.toUpperCase()}
              </div>
              <div style={{
                fontFamily: "JetBrains Mono,monospace", fontSize: 14, fontWeight: 900,
                color: C.green, letterSpacing: 3, wordBreak: "break-all", lineHeight: 2,
              }}>{keyData?.license_key}</div>
            </div>

            <div style={{
              background: "rgba(251,146,60,0.08)", border: "1px solid rgba(251,146,60,0.3)",
              borderRadius: 10, padding: "10px 14px", marginBottom: 14,
              display: "flex", gap: 10, alignItems: "center",
            }}>
              <span style={{ fontSize: 16, flexShrink: 0 }}>⚠️</span>
              <div style={{ fontSize: 11, color: "#fb923c", fontWeight: 700 }}>
                KEEP THIS KEY SAFE — Lost keys cannot be recovered
              </div>
            </div>

            <button onClick={copyFinalKey} style={{
              width: "100%", padding: "13px", marginBottom: 8,
              background: keyCopied ? `${C.green}22` : "linear-gradient(135deg,#38bdf8,#34d399)",
              border: keyCopied ? `1px solid ${C.green}` : "none",
              borderRadius: 10, color: keyCopied ? C.green : "#05080f",
              fontSize: 13, fontWeight: 800, cursor: "pointer", transition: "all 0.25s",
            }}>
              {keyCopied ? "✅ Copied!" : "📋 Copy License Key"}
            </button>

            <button onClick={downloadToolkey} style={{
              width: "100%", padding: "12px", marginBottom: 8,
              background: "rgba(56,189,248,0.08)", border: `1px solid ${C.accent}44`,
              borderRadius: 10, color: C.accent, fontSize: 13, fontWeight: 700, cursor: "pointer",
            }}>
              💾 Download toolkey.zip
            </button>

            <button onClick={onClose} style={{
              width: "100%", padding: "14px",
              background: "linear-gradient(135deg,#34d399,#38bdf8)",
              border: "none", borderRadius: 10, color: "#05080f",
              fontSize: 14, fontWeight: 800, cursor: "pointer",
            }}>
              ✅ Finish — Back to TOOLREX
            </button>
          </div>
        )}

        {/* STEP 6 — Rules */}
        {step === "rules" && (
          <div>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>📜</div>
              <div style={{ fontSize: 14, fontWeight: 800, color: C.accent,
                fontFamily: "Orbitron,monospace", letterSpacing: "0.06em" }}>
                TOOLREX RULES
              </div>
              <div style={{ fontSize: 10, color: C.muted, marginTop: 4 }}>
                By using your key, you agree to all terms below
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 20 }}>
              {TOOLREX_RULES.map((rule, i) => (
                <div key={i} style={{
                  display: "flex", gap: 12, alignItems: "flex-start",
                  background: ruleIdx >= i ? "rgba(56,189,248,0.04)" : "transparent",
                  border: `1px solid ${ruleIdx >= i ? C.accent + "22" : C.border}`,
                  borderRadius: 8, padding: "10px 12px",
                  transition: "all 0.3s",
                }}>
                  <div style={{
                    width: 22, height: 22, borderRadius: "50%", flexShrink: 0,
                    background: ruleIdx >= i ? C.accent : C.border,
                    color: ruleIdx >= i ? "#05080f" : C.muted,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 9, fontWeight: 900, fontFamily: "Orbitron,monospace",
                    transition: "all 0.3s",
                  }}>{i+1}</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: ruleIdx >= i ? C.text : C.muted,
                    lineHeight: 1.6, transition: "color 0.3s" }}>
                    {rule}
                  </div>
                </div>
              ))}
            </div>
            {ruleIdx < TOOLREX_RULES.length - 1 ? (
              <button onClick={() => setRuleIdx(r => r + 1)} style={{
                width: "100%", padding: "13px",
                background: "linear-gradient(135deg,#38bdf8,#7c3aed)",
                border: "none", borderRadius: 10, color: "#fff",
                fontSize: 13, fontWeight: 800, cursor: "pointer",
              }}>
                Read Next Rule ({ruleIdx + 2}/{TOOLREX_RULES.length})
              </button>
            ) : (
              <button onClick={() => setStep("download")} style={{
                width: "100%", padding: "13px",
                background: "linear-gradient(135deg,#34d399,#38bdf8)",
                border: "none", borderRadius: 10, color: "#05080f",
                fontSize: 13, fontWeight: 800, cursor: "pointer",
              }}>
                ✅ I Agree to All Rules — Get My Download →
              </button>
            )}
          </div>
        )}

      </div>
    </div>
  );
}

function inl(text) {
  return text.split(/(\*\*.*?\*\*|`.*?`)/g).map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**"))
      return (
        <strong key={i} style={{ color: "#38bdf8", fontWeight: 700 }}>
          {p.slice(2, -2)}
        </strong>
      );
    if (p.startsWith("`") && p.endsWith("`"))
      return (
        <code
          key={i}
          style={{
            background: "rgba(0,0,0,0.4)",
            padding: "1px 4px",
            borderRadius: 3,
            fontFamily: "JetBrains Mono,monospace",
            fontSize: 9,
            color: "#34d399",
          }}
        >
          {p.slice(1, -1)}
        </code>
      );
    return p;
  });
}
